import { internal, template } from '../../vendor/elix.js';

import WithSlotMixin from '../mixins/with-slot-mixin.js';
import TpButton from '../buttons/tp-button.js';

const TEXT_NODE = 3;

const isMicrosoftEdge = typeof HTMLSlotElement === 'undefined';

class TpChoiceChip extends WithSlotMixin(TpButton, 'leading', 'prepend') {

  get selected() {
    return this[internal.state].selected;
  }

  set selected(selected) {
    const isSelected = selected === true || selected === 'true';
    this[internal.setState]({ selected: isSelected });
  }

  getContainerToAnnotateWithClassName() {
    return this[internal.ids].inner;
  }

  getTemplateContainerToAppendSlotsTo(template) {
    return template.querySelector('#inner');
  }

  [internal.componentDidMount]() {
    super[internal.componentDidMount]();
    this.addEventListener('click', () => this.toggleSelected());
    this.wrapSlottedText();
  }

  toggleSelected() {
    this.selected = !this.selected;
    this.dispatchEvent(new CustomEvent('change', { bubbles: true, cancelable: true }));
  }

  [internal.render](changed) {
    super[internal.render](changed);
    if (changed.selected) {
      this.renderSelected();
    }
  }

  renderSelected() {
    const inner = this[internal.ids].inner;
    
    if (this.selected) {
      inner.classList.add('selected');
    } else {
      inner.classList.remove('selected');
    }
    
    if (isMicrosoftEdge) {
      const slot = this.querySelector('[slot]');
      if (slot) {
        if (this.selected) {
          slot.classList.add('selected');
        } else {
          slot.classList.remove('selected');
        }
      }
    }
  }

  wrapSlottedText() {
    this.childNodes.forEach((node) => {
      if (node.nodeType === TEXT_NODE) {
        let span = document.createElement('span');
        this.replaceChild(span, node);
        span.appendChild(node);
      }
    });
  }

  get [internal.template]() {

    return template.concat(
      super[internal.template],
      template.html`

        <style>
     
          :host {
            position: relative;
          }

          #inner {
            background-color: var(--tp-choice-chip-background-color);
            border-radius: 17px;
            color: var(--tp-choice-chip-font-color);
            cursor: pointer;
            font-family: var(--tp-choice-chip-font-family);
            font-size: var(--tp-choice-chip-font-size);
            height: 34px;
            padding: 0px 12px;
          }

          #inner:hover:enabled,
          #inner:focus:enabled,
          #inner:active:enabled {
            --tp-ripple-mixin-background-color: var(--tp-choice-chip-background-color);
          }

          #inner.selected {
            background-color: var(--tp-choice-chip-background-color-selected);
            color: var(--tp-choice-chip-font-color-selected);
          }
 
          #inner.selected:enabled {
            --tp-ripple-mixin-background-color: var(--tp-choice-chip-background-color-selected);
          }
    
          ::slotted(*) {
            opacity: var(--tp-choice-chip-opacity);
          }
          
          #inner:disabled {
            opacity: 1;
          }

          #inner.with-leading-slot-contents {
            padding-left: 44px;
          }

          slot[name=leading]::slotted(*) {
            left: 12px;
            pointer-events: none;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            z-index: 1;
          }

        </style>
        `,
        isMicrosoftEdge
          ? template.html`<style>
            [slot].selected,
            :host([selected]:not([disabled])) ::slotted(*),
            :host(:hover:not([disabled])) ::slotted(*) {
              opacity: var(--tp-choice-chip-opacity-active);
            }

            :host([disabled]) ::slotted(*) {
              opacity: var(--tp-choice-chip-opacity-disabled);
            }
          </style>`
          : template.html`<style>
            #inner:hover:enabled ::slotted(*),
            #inner:focus:enabled ::slotted(*),
            #inner:active:enabled ::slotted(*),
            #inner.selected:enabled ::slotted(*) {
              opacity: var(--tp-choice-chip-opacity-active);
            }

            #inner:disabled ::slotted(*) {
              opacity: var(--tp-choice-chip-opacity-disabled);
            }
     
          </style>`
    );

  }

}

export default TpChoiceChip;


